var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type"},[_c('p',[_vm._v("单位类别设备分布图")]),_c('div',{attrs:{"id":"typepie"}})])}]

export { render, staticRenderFns }